import { useData } from 'modules/corporatehub/context/dataContext';
import React from 'react';
import * as Styled from './StyledCorporateHubChallenges';
import LeftSession from './components/LeftSession';
import RightSession from './components/RightSession';

export default function CorporateHubExecutiveView() {
    const dataContext = useData();
    const { executivesPageVars } = dataContext.state;
    const { company } = dataContext.state;

    const companyName = company.isCxiGroup ? `do grupo ${company.name}` : company.name;

    return (
        <Styled.SessionContainer>
            <LeftSession data={executivesPageVars} />
            <RightSession data={executivesPageVars} companyName={companyName} />
        </Styled.SessionContainer>
    );
}
